import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { NavLink, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { roles } from '../../common/config'
import Logo from '../components/Logo'
import Button from '../components/Button'
import ProfileNav from '../components/ProfileNav'
import NotificationsHeader from '../components/NotificationsHeader'


class Header extends React.Component {
  componentDidCatch(error, info) {
    console.log('error - Header')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  render() {
    const { viewer, location, intl } = this.props

    const isUser = viewer && viewer.role === roles.USER

    return (
      <React.Fragment>
        <header className="header">
          <div className="app-nav">
            <nav className="logged-user-nav">
              <Link className="logo" to={viewer ? '/app' : '/'}>
                <Logo />
              </Link>
              {
                viewer ?
                  <React.Fragment>
                    {
                      isUser &&
                      <React.Fragment>
                        <NavLink id="nav-link-home" className="app-nav-link" to="/student-landing">
                          {intl.formatMessage(messages.home)}
                        </NavLink>
                        <NavLink id="nav-link-results" className="app-nav-link" to="/app/my-results">
                          {intl.formatMessage(messages.results)}
                        </NavLink>
                      </React.Fragment>
                    }
                    <NavLink id="nav-link-lessons" className="app-nav-link" to="/app/lessons">
                      {intl.formatMessage(messages.exercises)}
                    </NavLink>
                    {
                      !isUser &&
                      <React.Fragment>
                        <NavLink id="nav-link-tests" className="app-nav-link" to="/app/tests">
                          {intl.formatMessage(messages.tests)}
                        </NavLink>
                        <NavLink id="nav-link-homeworks" className="app-nav-link" to="/app/homeworks">
                          {intl.formatMessage(messages.homeworks)}
                        </NavLink>
                        <NavLink id="nav-link-groups" className="app-nav-link" to="/app/groups">
                          {intl.formatMessage(messages.classes)}
                        </NavLink>
                      </React.Fragment>
                    }
                    {
                      viewer.role === roles.ADMIN &&
                      <NavLink className="app-nav-link" to="/app/admin">Štatistiky</NavLink>
                    }
                  </React.Fragment>
                :
                  <h2 className="static-title">VOBO</h2>
              }
            </nav>
          </div>
          <div className="user-nav">
            {
              viewer ?
                <nav className="logged-user-nav">
                  <Link className="create-link" to="/app/create-lesson">
                    <Button positive>
                      + {intl.formatMessage(messages.create)}
                    </Button>
                  </Link>
                  <NotificationsHeader />
                  <ProfileNav />
                  <Link id="nav-link-search" to="/app/search">
                    <FontAwesomeIcon icon="search" size="2x" />
                  </Link>
                </nav>
              :
                !location.pathname.includes('test') &&
                <nav>
                  <Link to="/sign-up">{intl.formatMessage(messages.signUp)}</Link>
                  <Link to="/sign-in">{intl.formatMessage(messages.signIn)}</Link>
                </nav>
            }
          </div>
        </header>
        <div
          className="mobile-nav"
          style={isUser ? { flex: '0 0 25%;' } : null}
        >
          {
            viewer ?
              <nav>
                {
                  viewer.role === roles.USER &&
                  <NavLink className="mobile-menu-link" to="/student-landing">
                    {intl.formatMessage(messages.home)}
                  </NavLink>
                }
                <NavLink className="mobile-menu-link" to="/app/lessons">
                  {intl.formatMessage(messages.exercises)}
                </NavLink>
                {
                  (viewer.role === roles.TEACHER || viewer.role === roles.ADMIN) &&
                  (
                    <NavLink to="/app/tests">
                      {intl.formatMessage(messages.tests)}
                    </NavLink>
                  )
                }
                <NavLink className="mobile-menu-link" to="/app/search">
                  {intl.formatMessage(messages.search)}
                </NavLink>
                <NavLink className="mobile-menu-link" to="/app/create-lesson">
                  {intl.formatMessage(messages.create)}
                </NavLink>
                <NavLink className="mobile-menu-link" to="/sign-out">
                  {intl.formatMessage(messages.logOut)}
                </NavLink>
              </nav>
          :
            <nav>
              <NavLink
                className="mobile-menu-link logged-out-menu-link"
                to="/sign-up"
              >
                {intl.formatMessage(messages.signUp)}
              </NavLink>
              <NavLink
                className="mobile-menu-link logged-out-menu-link"
                to="/sign-in"
              >
                {intl.formatMessage(messages.signIn)}
              </NavLink>
            </nav>
          }
        </div>
      </React.Fragment>
    )
  }
}

Header.defaultProps = {
  viewer: null,
  location: null,
}

Header.propTypes = {
  intl: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  location: PropTypes.object,
}

const enhance = compose(
  connect(() => ({ }), { }),
  injectIntl,
)

export default enhance(withRouter(Header))

const messages = defineMessages({
  home: {
    id: 'header.home',
    defaultMessage: 'Domov',
  },
  exercises: {
    id: 'header.exercises',
    defaultMessage: 'Cvičenia',
  },
  results: {
    id: 'header.results',
    defaultMessage: 'Výsledky',
  },
  tests: {
    id: 'header.tests',
    defaultMessage: 'Testy',
  },
  homeworks: {
    id: 'header.homeworks',
    defaultMessage: 'Úlohy',
  },
  classes: {
    id: 'header.classes',
    defaultMessage: 'Triedy',
  },
  about: {
    id: 'header.about',
    defaultMessage: 'O aplikácii',
  },
  create: {
    id: 'header.create',
    defaultMessage: 'Vytvoriť',
  },
  search: {
    id: 'header.search',
    defaultMessage: 'Hladať',
  },
  signIn: {
    id: 'header.signIn',
    defaultMessage: 'Prihlásiť sa',
  },
  signUp: {
    id: 'header.signUp',
    defaultMessage: 'Registrovať',
  },
  logOut: {
    id: 'header.logOut',
    defaultMessage: 'Odhlásiť',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/Header.js